import { PatientModel } from "../../Services/Models/Patient/PatientModel";
// import { PatientTableMock } from "../../Services/Mocks/PatientTableMock";
import { getBio } from "./APIResources";
import { axiosWithToken } from "../../Services/Axios";
  
  // Add Patient
  export function addPatientAPI(values: PatientModel) {
    // return axios.post(ADD_PATIENT, patient);
    try{
      if(values){
        return {...values}
      }else{
        return {message: "Unable to register, please try again"}  
      }
    }catch(error){
      return {message: error}
    }
  }

  export function addPatientMultipleAPI(values: PatientModel[]) {
    try{
      if(values){
        return [...values]
      }else{
        return {message: "Unable to register, please try again"}  
      }
    }catch(error){
      return {message: error}
    }
  }

  export function updatePatients(patients: PatientModel[]) {
    try{
      return {...patients};
    }catch(error){
      return {message: error};
    }
  }
  
  export async function getPatientVitals(start: number, end: number, type: string = "all", device_id: string = "648aec6ddc9364d08e1bda49", child_id: string = "64881e41562b2da2b5117c54"){
    try{
      return await axiosWithToken.get(`${getBio}?type=${type}&start=${start}&end=${end}&device_id=${device_id}&child_id=${child_id}`);
    } catch(error) {
      return {message: error}
    }
  }

  export async function getPatientAlerts(start: number, end: number, type: string = "alerts", device_id: string = "648aec6ddc9364d08e1bda49", child_id: string = "64881e41562b2da2b5117c54"){
    try{
      return await axiosWithToken.get(`${getBio}?type=${type}&start=${start}&end=${end}&device_id=${device_id}&child_id=${child_id}`);
    } catch(error) {
      return {message: error}
    }
  }
  